import {translationBaseKey} from '../../../../../decorators/translation-base-key.decorator';
import {clonePropertyMetadata} from '@pristine-ts/metadata';
import {
    IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions,
} from '../../../income-tax/personal/personal/income-tax-personal-child-quebec-in-income-tax-personal.options';

@translationBaseKey('income-tax-personal-child-quebec-in-salary-dividend-options')
export class IncomeTaxPersonalChildQuebecInSalaryDividendOptions implements IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions {
  @clonePropertyMetadata<IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions>(IncomeTaxPersonalChildQuebecInIncomeTaxPersonalOptions, 'careExpensesOthers')
  careExpensesOthers: number;
}